import React from 'react';
import { CheckBox } from '@itglue/kaseya-ui';

interface IProps {
    className?: string;
    label?: string;
    name: string;
    checked: boolean | 'mixed';
    onChange?: (checked: boolean, event: React.ChangeEvent) => void;
    disabled?: boolean;
}

export const PasslyCheckbox = (props: IProps) => {
    const { className, label, name, checked, onChange, disabled } = props;

    return (
        <CheckBox
            fieldLabel={label}
            name={name}
            className={`passlyCheckbox ${className}`}
            value={checked}
            onChange={onChange}
            disabled={disabled}
        />
    );
};
